if (typeof PAR === "undefined") var PAR = {};
if (typeof PAR.maps === "undefined") PAR.maps = [];

PAR.constants = {
    mq: {
        phone: 768,
        tablet: 992,
    },
};

PAR.hashTagActive = "";

/**
 * Determines wether the current page is a clinic page or clinic subpage
 */
PAR.isClinicPage = function () {
    return (
        jQuery("body").hasClass("page-template-clinic-department") ||
        jQuery("body").hasClass("page-template-clinic-main") ||
        jQuery("body").hasClass("page-template-clinic-sub")
    );
};

/**
 * Determines wether the current page is a clinic main page
 */
PAR.isClinicMain = function () {
    return jQuery("body").hasClass("page-template-clinic-main");
};

/**
 * Determines wether the current page is a clinic sub page
 */
PAR.isClinicSub = function () {
    return jQuery("body").hasClass("page-template-clinic-department") || jQuery("body").hasClass("page-template-clinic-sub");
};

/**
 * Init a single map by config
 */
PAR.initSingleMap = function (mapConfig) {
    if (typeof google === "undefined") {
        console.log("google not found");
        return false;
    }

    var map,
        j,
        marker,
        markers,
        markerConfig,
        markerIcon = {
            url: "/wp-content/themes/par/img/ico-location-filled.svg",
            anchor: new google.maps.Point(14, 40),
            scaledSize: new google.maps.Size(21, 30),
        };

    //-- Init map --
    map = new google.maps.Map(document.getElementById(mapConfig["containerId"]), {
        center: { lat: mapConfig["latitude"], lng: mapConfig["longitude"] },
        zoom: mapConfig["zoom"],
        styles: PAR.maps_styling,
    });

    //-- Init markers --
    markers = [];
    for (j = 0; j < mapConfig.markers.length; j++) {
        markerConfig = mapConfig.markers[j];

        marker = new google.maps.Marker({
            map: map,
            icon: markerIcon,
            position: new google.maps.LatLng(markerConfig.latitude, markerConfig.longitude),
            data: markerConfig.data,
        });

        //Handle click on marker
        google.maps.event.addListener(
            marker,
            "click",
            (function (targetMarker, k) {
                return function () {
                    var infowindow = new google.maps.InfoWindow();

                    var markerContent =
                        '<span class="marker-title"> ' +
                        targetMarker.data.title +
                        "</span>" +
                        '<span class="marker-street"> ' +
                        targetMarker.data.address.street +
                        "</span>" +
                        '<span class="marker-zipcode"> ' +
                        targetMarker.data.address.zipcode +
                        "</span>" +
                        '<span class="marker-city"> ' +
                        targetMarker.data.address.city +
                        "</span>" +
                        '<a class="marker-more" href="' +
                        targetMarker.data.page +
                        '"> Mehr Infos</a>';

                    infowindow.setContent(markerContent);
                    infowindow.open(targetMarker.map, targetMarker);
                };
            })(marker, j)
        );

        markers.push(marker);
    }

    var markerCluster = new MarkerClusterer(map, markers, {
        gridSize: 30,
        styles: [
            {
                width: 43,
                height: 43,
                url: "/wp-content/themes/par/img/cluster-circle1.svg",
                textColor: "#A0005F",
                textSize: 14,
            },
        ],
    });
};

/**
 * Init google maps
 */
PAR.initMaps = function () {
    var i, mConfig;

    //-- Init gmaps --
    for (i = 0; i < PAR.maps.length; i++) {
        mConfig = PAR.maps[i];
        PAR.initSingleMap(mConfig);
    }
};

/**
 * Handles the click on the page menu item
 */
PAR.cbPageMenuClick = function (e) {
    var linkEl = jQuery(e.target),
        pageMenu = linkEl.closest("ul"),
        selector = pageMenu.data("pagemenu-selector");

    if (PAR.hashTagActive == linkEl) {
        return;
    }
    e.preventDefault;

    if (!selector || selector == "") {
        selector =
            ".entry-content > h2, .entry-content .wp-block-group__inner-container > h2, .entry-content .wp-block-column > h2, .entry-content .wp-block-media-text__content > h2";
    }
    // ".entry-content > h2, .entry-content .wp-block-group__inner-container > h2, .entry-content .wp-block-column > h2, .entry-content .wp-block-media-text__content > h2"
    // aus landingpage
    //-- Mark link as active --
    jQuery("#par-pagemenu a, .par-pagemenu a").removeClass("active");
    linkEl.addClass("active");

    //console.log(selector);
    var targetIndex = jQuery(e.target).data("index"),
        targetEl = jQuery(selector).eq(targetIndex),
        dest = 0;

    if (typeof jQuery(targetEl).offset() !== "undefined") {
        console.log(jQuery(targetEl).offset());
        dest =
            jQuery(targetEl).offset().top > jQuery(document).height() - jQuery(window).height()
                ? jQuery(document).height() - jQuery(window).height()
                : jQuery(targetEl).offset().top - 20;
        // console.log(jQuery(targetEl).offset().top);
    }
    // console.log(dest);
    // console.log(jQuery(selector));
    // console.log("+++ e +++");
    // console.log(e.target);
    // console.log("+++ targetEl +++");
    // console.log(targetEl);
    if (targetEl && targetEl.length > 0) {
        jQuery("html,body").animate({ scrollTop: dest }, 400, "swing");
        PAR.hashTagActive = linkEl;
        //targetEl[0].scrollIntoView();
    }
    return false;
};

/**
 * Initialize page menu if available
 */
PAR.initPageMenu = function ($) {
    if ((!$("#par-pagemenu") || $("#par-pagemenu").length < 1) && (!$(".par-pagemenu") || $(".par-pagemenu").length < 1)) {
        return;
    }
    console.log("+++ par-pagemenu +++");
    var el = $("#par-pagemenu, .par-pagemenu"),
        par_el = $(".parent-menu").width(),
        posMenu = el && typeof el.offset() !== "undefined" ? el.offset().top - 20 : 0;

    el.on("click touchstart", "a", PAR.cbPageMenuClick);

    //-- Sticky --
    $(window).scroll(function (e) {
        if ($(this).scrollTop() > posMenu) {
            el.addClass("menu-fixed").width(par_el);
        }
        if ($(this).scrollTop() < posMenu) {
            el.removeClass("menu-fixed");
        }
    });
};

/**
 * Init the mobile menu
 * - move clinic menu into mainmenu
 */
PAR.initMobileMenu = function ($) {
    if (window.innerWidth >= PAR.constants.mq.tablet) {
        return;
    }
    //ToDo: React on window resize

    //-- Append static text to main menu --
    $("#par-initmobilemenu-nav-wrapper-nav-primary").prepend($('<h2 id="par-initmobilemenu-1">Paracelsus</h2>'));

    //-- Move clinit menu into main menu --
    if (PAR.isClinicPage()) {
        $("#par-initmobilemenu-nav-wrapper-nav-primary").prepend($("#par-initmobilemenu-nav-wrapper-nav .nav"));
    }

    //-- Move clinic title to main menu --
    if (PAR.isClinicMain()) {
        $("#par-initmobilemenu-nav-wrapper-nav-primary").prepend($('<h2 id="par-initmobilemenu-2">' + $("#header-clinic-main h1").html() + "</h2>"));
    }

    //-- Clinic clinic title to main menu --
    if (PAR.isClinicSub()) {
        $("#par-initmobilemenu-nav-wrapper-nav-primary").prepend($('<h2 id="par-initmobilemenu-3">' + $("#header-clinic-sub h1").html() + "</h2>"));
    }
};

/**
 *
 * @mh
 *
 */
PAR.resetMobileMenu = function ($) {

    //-- Append static text to main menu --
    $("#par-initmobilemenu-nav-wrapper-nav-primary #par-initmobilemenu-1").remove();
    console.log('remove #par-initmobilemenu-1');
    //-- Move clinit menu into main menu --
    if (PAR.isClinicPage()) {
        $("#par-initmobilemenu-nav-wrapper-nav").prepend($("#par-initmobilemenu-nav-wrapper-nav-primary .nav"));
        $("#par-initmobilemenu-nav-wrapper-nav-primary .nav").remove();
    }

    //-- Move clinic title to main menu --
    if (PAR.isClinicMain()) {
        $("#par-initmobilemenu-nav-wrapper-nav-primary #par-initmobilemenu-2").remove();
    }

    //-- Clinic clinic title to main menu --
    if (PAR.isClinicSub()) {
        $("#par-initmobilemenu-nav-wrapper-nav-primary #par-initmobilemenu-3").remove();
    }
};

PAR.initScroll = function ($) {
    $(".navbar-toggler").click(function (e) {
        $("body").toggleClass("no-scroll");
        $("#offcanvas").toggleClass("no-scroll");
    });
};


/**
 * Init the collapse for mobile submenu
 * - add collapse for third part submenu
 */
PAR.reinitCollapseMobileMenu = function ($) {
    if (window.innerWidth < PAR.constants.mq.tablet) {
        $(".dropdown-menu .wp-block-column").off("click");
        $(".dropdown-menu .wp-block-column").on("click", function (event) {
            event.stopPropagation();

            $(this).find("h2").parent().toggleClass("show");

            $(this).off("hidden.bs.dropdown");
            $(this)
                .parents(".show")
                .on("hidden.bs.dropdown", function (e) {
                    $(".dropdown-menu .show").removeClass("show");
                });
        });
    }
};

/**
 * Change submit text value from suche to search
 * - it can help add the icon
 */
PAR.initSearchIcon = function ($) {
    $(".search-form")
        .find(".search-submit")
        .ready(function () {
            $(".search-submit").val("search");
        });
};

/**
 * Init offcanvas behaviour
 *
 */
PAR.initOffCanvas = function ($) {
    $('[data-toggle="offcanvas"]').on("click touch", function () {
        $(".offcanvas-collapse").toggleClass("open");
    });

    $(".offcanvas-collapse a").on("click touch", function (e) {
        $(".offcanvas-collapse").removeClass("open");
        //$(e.target).addClass('active');
    });
};

/**
 * The scroll callback function for landing page
 */
PAR._cbLPScroll = function () {
    var $ = jQuery,
        scroll = $(window).scrollTop();

    if (scroll != PAR._initScrollPos) {
        $("body").addClass("scrolled-up");
        $(window).off("scroll", PAR._cbLPScroll);
    }
    PAR._initScrollPos = scroll;
};

/**
 * Init scroll detector for landing page
 */
PAR.initLPScollDetector = function ($) {
    PAR._initScrollPos = $(window).scrollTop();
    $(window).on("scroll", PAR._cbLPScroll);
};

/**
 * Init finder helpers
 */
PAR.initFinder = function ($) {
    $(".finder-submit").on("click", function (e) {
        $(e.target).closest("form").submit();
    });
};

/**
 * Init ecard function
 */
PAR.initEcards = function ($) {
    let preselected = false;

    $(".ecard-images-list").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
    });

    //-- Already checked show in preview --
    if ($(".ecard-images-list input:checked") && $(".ecard-images-list input:checked").length > 0) {
        var img = $(".ecard-images-list input:checked").closest("label").find("img");
        $(".preview-image").attr("src", img.attr("src"));
        $("#container-greeting-card .background-image").css("background-image", "url(" + img.attr("src") + ")");
        preselected = true;
    } else {
        var img = $(".ecard-images-list").find("img");
        $(".preview-image").attr("src", img.attr("src"));
        $("#container-greeting-card .background-image").css("background-image", "url(" + img.attr("src") + ")");
        preselected = true;
    }

    $(".ecard-images-list input").on("change", function (e) {
        var img = $(e.target).closest("label").find("img");
        $(".preview-image").attr("src", img.attr("src"));
        $("#container-greeting-card .background-image").css("background-image", "url(" + img.attr("src") + ")");
    });

    if (!preselected) {
        setTimeout(function () {
            $(".ecard-image.slick-current input").trigger("click");
        }, 100);
    }

    //-- Preview --
    if ($(".ecards-preview") && $(".ecards-preview").length > 0) {
        $("#container-greeting-card .background-image").css("background-image", $("#ecard-preview").css("background-image"));
    }

    //-- Show --
    if ($(".ecards-show") && $(".ecards-show").length > 0) {
        $("#container-greeting-card .background-image").css("background-image", "url(" + $(".ecards-show img").attr("src") + ")");
    }
};



/**
 * Bootstrapping
 */
jQuery(function ($) {
    setTimeout(function () {
        PAR.initPageMenu($);
    }, 1000); //Timeout to calculate correct position from top

    PAR.initScroll($);
    PAR.initMobileMenu($);
    PAR.initSearchIcon($);
    PAR.reinitCollapseMobileMenu($);
    PAR.initLPScollDetector($);
    PAR.initOffCanvas($);
    PAR.initFinder($);

    if ($("body").hasClass("page-template-greeting-card")) {
        PAR.initEcards($);
    }
});

window.addEventListener("resize", function () {
    jQuery(function ($) {
        PAR.resetMobileMenu($);
        PAR.initMobileMenu($);
        PAR.reinitCollapseMobileMenu($);
    });
});
